import React from 'react';
import PropTypes from 'prop-types';
import UserRepository from '../repository/UserRepository';
import { FirebaseState } from '../../components/firebase/MyFirebaseProvider';
import { AppState } from '../../components/state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER } from '../../components/state/seed-states';
import FirebaseRepository from '../../components/firebase/FirebaseRepository';
import { APP_STATE_ACTION_TYPE_RAFFLESIA_USER } from './rafflesia-states';

const RafflesiaUserProvider = (props) => {
  const {
    children,
  } = props;
  const { state, dispatch } = React.useContext(AppState);
  const { firebaseConfig } = React.useContext(FirebaseState);

  const [authRepo] = React.useState(new FirebaseRepository(state, dispatch, firebaseConfig));
  const [userRepo] = React.useState(new UserRepository(firebaseConfig, state));

  const generateUsername = (user) => {
    let newUsername;
    if (user.email) {
      newUsername = user.email.split('@')[0].replace('.', '');
    } else {
      newUsername = `user${user.phoneNumber.replace('+', '').substring(5)}`;
    }
    return newUsername;
  };

  React.useEffect(() => {
    if (authRepo.isAuthenticated()) {
      const userState = state[APP_STATE_ACTION_TYPE_USER];
      if (userState) {
        const { user } = userState;
        const initialUserData = {
          photoURL: user.photoURL,
          username: generateUsername(user),
          creationTime: user.creationTime,
        };
        userRepo.setupUser(user.uid, initialUserData)
          .then((response) => {
            const { data: responseData } = response;
            const { data } = responseData;
            dispatch({
              type: APP_STATE_ACTION_TYPE_RAFFLESIA_USER,
              value: data.payload,
              valueType: 'json',
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }

    return () => {

    };
  }, [authRepo, userRepo]);

  return (
    <>
      {children}
    </>
  );
};

RafflesiaUserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RafflesiaUserProvider;
